<template>
  <Btn
    class="btn-primary pr-0 btn-toggle-grid"
    :class="{ 'd-none': isHidden }"
    icon="arrow-right"
    :icon-rotate="upperGridIsActive ? 90 : -90"
    @click.native="toggleActiveGrid"
  >
    <template slot="prepend">{{ buttonText }}</template>
  </Btn>
</template>

<script>
import Btn from '@/components/atoms/HeraFormBtn';
import { translate } from '@/mixins/translate';
import { globalEventListener } from '@/utils/globalEvent';
import { prop } from '@/utils/factories';
export default {
  name: 'ToggleGrid',
  components: { Btn },
  mixins: [translate('_web_toggle-grid')],
  props: {
    dataIsFetched: prop(Boolean),
  },
  data() {
    return {
      isHidden: false,
      upperGridIsActive: true, // 0 - upper or 1 - lower,
      debounceScroll: this.$lodash.debounce(this.checkGridTop, 200),
      debounceResize: this.$lodash.debounce(this.checkGridHeight, 200),
    };
  },
  computed: {
    buttonText() {
      return this.upperGridIsActive
        ? this.$$t('Go to lower')
        : this.$$t('Go to upper');
    },
  },
  mounted() {
    /*
      grids[0] - upper grid
      grids[1] - lower grid
      grids[activeGrid] - current grid
       */
    this.$options.lowerGrid = this.$el.parentElement.children[1];
    this.$options.minTop = document
      .querySelector('#breadcrumbsWrapper')
      .getBoundingClientRect().bottom;

    globalEventListener('add', 'scroll.toggleGrid', this.debounceScroll);
    globalEventListener('add', 'resize.toggleGrid', this.debounceResize);
    this.$emit('created', this);
  },
  destroyed() {
    globalEventListener('remove', '.toggleGrid');
  },
  methods: {
    checkGridTop() {
      const { minTop } = this.$options;
      const { top } = this.$options.lowerGrid.getBoundingClientRect();

      if (this.upperGridIsActive && top < minTop) {
        this.upperGridIsActive = false;
      } else if (!this.upperGridIsActive && top > minTop) {
        // 10 - is delta for detect
        this.upperGridIsActive = true;
      }
    },
    checkGridHeight() {
      const { height } = this.$options.lowerGrid.getBoundingClientRect();
      this.isHidden = height < window.outerHeight / 1.5;
    },
    toggleActiveGrid() {
      const scrollTop = this.upperGridIsActive
        ? this.$options.lowerGrid.getBoundingClientRect().top -
          (this.$options.minTop || 0) +
          document.documentElement.scrollTop
        : 0;
      window.scroll(0, scrollTop);
      this.upperGridIsActive = !this.upperGridIsActive;
    },
  },
};
</script>

<style lang="scss">
.btn-toggle-grid {
  position: fixed !important;
  z-index: 22;
  bottom: 2rem;
  right: 3rem; // not rtl
  border-radius: $border-radius !important;
  .svg-icon-wrapper {
    margin-right: 0 !important;
  }
}
</style>
